import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import Topic from "components/pages/Topic";

interface Props {
  isMobile: boolean;
  initialTopicList?: any[] | null;
}

const TopicPage: NextPage<Props> = ({ isMobile, initialTopicList }) => {
  return <Topic isMobile={isMobile} initialTopicList={initialTopicList} />;
};

export default TopicPage;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";
  const base = process.env.NEXTAUTH_URL;

  let initialTopicList: any[] | null = null;
  try {
    const res = await fetch(`${base}/api/hotTopic?limit=100`);
    if (res.ok) initialTopicList = await res.json();
  } catch {
    initialTopicList = null;
  }

  return {
    props: {
      initialTopicList,
      ...(await serverSideTranslations(locale, [""])),
    },
  };
}
